import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v("Whitelist Maintenance"),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v("Business Domains and Subdomains"),
              ]),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: {
                    click: function ($event) {
                      _vm.tab == 0
                        ? _vm.openDialog()
                        : _vm.tab == 1
                        ? _vm.openDialog2(null, "crear")
                        : _vm.openDialog3()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.filter_enabled
        ? _c(
            VCard,
            { staticClass: "d-block d-md-none mb-2" },
            [
              _c(VCardTitle, { staticClass: "pointer" }, [
                _vm._v(_vm._s(_vm.$t("titles.search_filters"))),
              ]),
              _c(
                VCardText,
                { staticClass: "pa-2" },
                [
                  _c(VRow, { attrs: { dense: "" } }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VTextField, {
                          attrs: {
                            label: _vm.$t("form_profile.email"),
                            placeholder: _vm.$t("form_profile.email"),
                            outlined: "",
                            dense: "",
                          },
                          model: {
                            value: _vm.filters.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "email", $$v)
                            },
                            expression: "filters.email",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c(VTextField, {
                          attrs: {
                            label: _vm.$t("filtros.organization"),
                            placeholder: _vm.$t("filtros.organization"),
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onSearch($event)
                            },
                          },
                          model: {
                            value: _vm.filters.domain,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "domain", $$v)
                            },
                            expression: "filters.domain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 text-right" },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "default mr-1",
                            attrs: { outlined: "" },
                            on: { click: _vm.onLimpiar },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                        ),
                        _c(
                          VBtn,
                          {
                            staticClass: "primary ",
                            on: { click: _vm.onSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.search")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(
                  VTabs,
                  {
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c(VTab, [_vm._v("Whitelist")]),
                    _c(
                      VTabItem,
                      [
                        _c(VDataTable, {
                          staticClass: "table-inca",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.select_whitelist,
                            "hide-default-footer": "",
                            "items-per-page": _vm.pagination_1.limit,
                            page: _vm.pagination_1.current,
                          },
                          on: {
                            pagination: function ($event) {
                              _vm.pagination_1.total = $event.itemsLength
                            },
                            "update:page": function ($event) {
                              return _vm.$set(
                                _vm.pagination_1,
                                "current",
                                $event
                              )
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.actions",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteWhitelist(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("icon-delete"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Delete Email")])]
                                  ),
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editWhitelist(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("icon-edit"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Editar Email")])]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(VTab, [_vm._v("Router Session")]),
                    _c(
                      VTabItem,
                      [
                        _c(VDataTable, {
                          staticClass: "table-inca",
                          attrs: {
                            headers: _vm.headers2,
                            items: _vm.router_sessions,
                            "hide-default-footer": "",
                            "items-per-page": _vm.pagination_2.limit,
                            page: _vm.pagination_2.current,
                          },
                          on: {
                            pagination: function ($event) {
                              _vm.pagination_2.total = $event.itemsLength
                            },
                            "update:page": function ($event) {
                              return _vm.$set(
                                _vm.pagination_2,
                                "current",
                                $event
                              )
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.active",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.active ? "Activo" : "No activo"
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "item.actions",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDialog2(
                                                              item,
                                                              "editar"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("icon-edit"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Edit Organization")])]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(VTab, [_vm._v("Lista Blanca Accesos AD")]),
                    _c(
                      VTabItem,
                      [
                        _c(VDataTable, {
                          staticClass: "table-inca",
                          attrs: {
                            headers: _vm.headers3,
                            items: _vm.select_whitelist_ad,
                            "hide-default-footer": "",
                            "items-per-page": _vm.pagination_3.limit,
                            page: _vm.pagination_3.current,
                          },
                          on: {
                            pagination: function ($event) {
                              _vm.pagination_3.total = $event.itemsLength
                            },
                            "update:page": function ($event) {
                              return _vm.$set(
                                _vm.pagination_3,
                                "current",
                                $event
                              )
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.actions",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteWhitelistAd(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("icon-delete"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Delete Email")])]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.tab == 0
              ? _c("pagination-vue", {
                  attrs: { pagination: _vm.pagination_1 },
                })
              : _vm._e(),
            _vm.tab == 1
              ? _c("pagination-vue", {
                  attrs: { pagination: _vm.pagination_2 },
                })
              : _vm._e(),
            _vm.tab == 2
              ? _c("pagination-vue", {
                  attrs: { pagination: _vm.pagination_3 },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$t("form_profile.email"),
                                    placeholder: _vm.$t("form_profile.email"),
                                    outlined: "",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.filters.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "email", $$v)
                                    },
                                    expression: "filters.email",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c("organizacion-component", {
                                  attrs: {
                                    custom_orgs: _vm.list_orgs,
                                    show_all: false,
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSearch($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.filters.domain,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "domain", $$v)
                                    },
                                    expression: "filters.domain",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: { click: _vm.onLimpiar },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary ",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialogs-component",
        { ref: _vm.DIALOG_ROUTER, attrs: { title: "Crear" } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form2" },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("tablas.organization")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "Organization is required"
                                },
                              ],
                            },
                            model: {
                              value: _vm.router_aux.id,
                              callback: function ($$v) {
                                _vm.$set(_vm.router_aux, "id", $$v)
                              },
                              expression: "router_aux.id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("tablas.dominio_empresa")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "Domain is required"
                                },
                              ],
                            },
                            model: {
                              value: _vm.router_aux.domain,
                              callback: function ($$v) {
                                _vm.$set(_vm.router_aux, "domain", $$v)
                              },
                              expression: "router_aux.domain",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("tablas.status")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VSwitch, {
                            model: {
                              value: _vm.router_aux.active,
                              callback: function ($$v) {
                                _vm.$set(_vm.router_aux, "active", $$v)
                              },
                              expression: "router_aux.active",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createRouter()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.DIALOG_WHITELIST,
          attrs: {
            title:
              (_vm.edit_whitelist ? "Actualizar" : "Crear") +
              " Lista Blanca Por Usuario",
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form" },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("form_profile.email")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              readonly: _vm.edit_whitelist,
                              dense: "",
                              outlined: "",
                              filled: _vm.edit_whitelist,
                              rules: [
                                function (v) {
                                  return !!v || "E-mail is required"
                                },
                                function (v) {
                                  return (
                                    /[a-z0-9]+@[a-z]+.[a-z].[a-z]{2,3}/.test(
                                      v
                                    ) || "E-mail must be valid"
                                  )
                                },
                              ],
                            },
                            model: {
                              value: _vm.whitelist_aux.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.whitelist_aux, "email", $$v)
                              },
                              expression: "whitelist_aux.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("tablas.organization") + " Actual"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c("organizacion-component", {
                            attrs: {
                              custom_orgs: _vm.list_orgs,
                              rules: [
                                function (v) {
                                  return !!v || "Organization is required"
                                },
                              ],
                              show_all: false,
                            },
                            model: {
                              value: _vm.whitelist_aux.domain,
                              callback: function ($$v) {
                                _vm.$set(_vm.whitelist_aux, "domain", $$v)
                              },
                              expression: "whitelist_aux.domain",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Empresas Adicionales (Opcional)"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c("organizacion-component", {
                            attrs: {
                              custom_orgs: _vm.list_orgs,
                              show_all: false,
                              label: "Empresa en INCA",
                              multiple: true,
                            },
                            model: {
                              value: _vm.whitelist_aux.domains_optional,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.whitelist_aux,
                                  "domains_optional",
                                  $$v
                                )
                              },
                              expression: "whitelist_aux.domains_optional",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createWhitelist()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.DIALOG_WHITELIST_AD,
          attrs: { title: "Crear Lista Blanca AD" },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form3" },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("form_profile.email")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "E-mail is required"
                                },
                                function (v) {
                                  return (
                                    /^[a-z0-9._-]+@[a-z0-9.-]+.[a-z]{2,4}$/.test(
                                      v
                                    ) || "E-mail must be valid"
                                  )
                                },
                              ],
                            },
                            on: {
                              input: function ($event) {
                                _vm.whitelist_ad_aux.email = $event
                                  .toLowerCase()
                                  .trim()
                              },
                            },
                            model: {
                              value: _vm.whitelist_ad_aux.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.whitelist_ad_aux, "email", $$v)
                              },
                              expression: "whitelist_ad_aux.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Tipo de AD"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              label: "Tipo de AD",
                              outlined: "",
                              dense: "",
                              rules: [
                                function (v) {
                                  return !!v || "AD Type is required"
                                },
                              ],
                              items: _vm.ads_list,
                            },
                            model: {
                              value: _vm.whitelist_ad_aux.ad,
                              callback: function ($$v) {
                                _vm.$set(_vm.whitelist_ad_aux, "ad", $$v)
                              },
                              expression: "whitelist_ad_aux.ad",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createWhitelistAd()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }